import React from 'react';
import './WhatWeBelieve.css';

const WhatWeBelieve = () => {
  // Get version from URL parameters
  const urlParams = new URLSearchParams(window.location.search);
  const version = urlParams.get('v') || '0';

  // Version 1: Modern Minimalist
  if (version === '1') {
    return (
      <section className="what-we-believe-v1">
        <div className="container-v1">
          <div className="content-grid-v1">
            <div className="hero-text-v1">
              <span className="since-badge-v1">Since 1994</span>
              <h1 className="main-title-v1">What We Believe In</h1>
              <p className="subtitle-v1">
                Our principles have been shaped by over 30 years of backing bold entrepreneurs and innovative businesses. Today, those principles guide our growth.
              </p>
            </div>
            <div className="values-grid-v1">
              <div className="value-item-v1">
                <div className="value-number-v1">01</div>
                <h3 className="value-title-v1">Innovation First</h3>
                <p className="value-desc-v1">We believe in backing revolutionary ideas that change industries.</p>
              </div>
              <div className="value-item-v1">
                <div className="value-number-v1">02</div>
                <h3 className="value-title-v1">Bold Entrepreneurs</h3>
                <p className="value-desc-v1">Supporting visionary leaders who dare to think differently.</p>
              </div>
              <div className="value-item-v1">
                <div className="value-number-v1">03</div>
                <h3 className="value-title-v1">Future Focus</h3>
                <p className="value-desc-v1">Building tomorrow's solutions with today's investments.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  // Version 2: Card-based Layout
  if (version === '2') {
    return (
      <section className="what-we-believe-v2">
        <div className="container-v2">
          <div className="header-v2">
            <h2 className="title-v2">What We Believe In</h2>
            <div className="year-badge-v2">Est. 1994</div>
          </div>
          <div className="cards-container-v2">
            <div className="belief-card-v2 card-primary">
              <div className="card-icon-v2">💡</div>
              <h3 className="card-title-v2">Innovation Investment</h3>
              <p className="card-text-v2">We invest in breakthrough technologies and disruptive business models that shape the future.</p>
              <a href="#" className="card-link-v2">Learn More →</a>
            </div>
            <div className="belief-card-v2 card-secondary">
              <div className="card-icon-v2">🚀</div>
              <h3 className="card-title-v2">Bold Ventures</h3>
              <p className="card-text-v2">Supporting entrepreneurs who challenge the status quo and create extraordinary value.</p>
              <a href="#" className="card-link-v2">Our Portfolio →</a>
            </div>
            <div className="belief-card-v2 card-accent">
              <div className="card-icon-v2">⭐</div>
              <h3 className="card-title-v2">Excellence</h3>
              <p className="card-text-v2">Delivering exceptional results through strategic partnerships and expert guidance.</p>
              <a href="#" className="card-link-v2">Our Team →</a>
            </div>
          </div>
        </div>
      </section>
    );
  }

  // Version 3: Split Diagonal Design
  if (version === '3') {
    return (
      <section className="what-we-believe-v3">
        <div className="split-container-v3">
          <div className="diagonal-left-v3">
            <div className="left-content-v3">
              <h2 className="diagonal-title-v3">What We<br/>Believe In</h2>
              <div className="stats-v3">
                <div className="stat-v3">
                  <span className="stat-number-v3">30+</span>
                  <span className="stat-label-v3">Years</span>
                </div>
                <div className="stat-v3">
                  <span className="stat-number-v3">500M+</span>
                  <span className="stat-label-v3">Invested</span>
                </div>
              </div>
            </div>
          </div>
          <div className="diagonal-right-v3">
            <div className="right-content-v3">
              <div className="principle-v3">
                <h3 className="principle-title-v3">Visionary Thinking</h3>
                <p className="principle-text-v3">We see opportunities where others see obstacles, investing in tomorrow's breakthroughs today.</p>
              </div>
              <div className="principle-v3">
                <h3 className="principle-title-v3">Strategic Partnership</h3>
                <p className="principle-text-v3">More than capital, we provide strategic guidance and industry expertise to our portfolio companies.</p>
              </div>
              <div className="principle-v3">
                <h3 className="principle-title-v3">Sustainable Growth</h3>
                <p className="principle-text-v3">Building lasting value through sustainable business practices and responsible innovation.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  // Version 4: Animated Timeline
  if (version === '4') {
    return (
      <section className="what-we-believe-v4">
        <div className="timeline-container-v4">
          <div className="timeline-header-v4">
            <h2 className="timeline-title-v4">Our Journey & Beliefs</h2>
            <p className="timeline-subtitle-v4">Three decades of innovation and growth</p>
          </div>
          <div className="timeline-v4">
            <div className="timeline-item-v4">
              <div className="timeline-date-v4">1994</div>
              <div className="timeline-content-v4">
                <h3 className="timeline-heading-v4">Foundation</h3>
                <p className="timeline-text-v4">Started with a vision to back bold entrepreneurs and foster innovation across industries.</p>
              </div>
            </div>
            <div className="timeline-item-v4">
              <div className="timeline-date-v4">2000s</div>
              <div className="timeline-content-v4">
                <h3 className="timeline-heading-v4">Technology Focus</h3>
                <p className="timeline-text-v4">Pivoted to technology investments, backing breakthrough innovations in software and biotech.</p>
              </div>
            </div>
            <div className="timeline-item-v4">
              <div className="timeline-date-v4">2010s</div>
              <div className="timeline-content-v4">
                <h3 className="timeline-heading-v4">Portfolio Expansion</h3>
                <p className="timeline-text-v4">Diversified into cybersecurity, blockchain, and emerging technologies.</p>
              </div>
            </div>
            <div className="timeline-item-v4">
              <div className="timeline-date-v4">Today</div>
              <div className="timeline-content-v4">
                <h3 className="timeline-heading-v4">Innovation Leaders</h3>
                <p className="timeline-text-v4">Leading the charge in transformative technologies and sustainable business practices.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  // Version 5: Magazine-style Layout
  if (version === '5') {
    return (
      <section className="what-we-believe-v5">
        <div className="magazine-container-v5">
          <div className="magazine-header-v5">
            <div className="magazine-meta-v5">
              <span className="magazine-category-v5">PHILOSOPHY</span>
              <span className="magazine-date-v5">Since 1994</span>
            </div>
            <h1 className="magazine-title-v5">What We Believe In</h1>
          </div>
          <div className="magazine-content-v5">
            <div className="magazine-main-v5">
              <p className="magazine-intro-v5">
                Our principles have been shaped by over 30 years of backing bold entrepreneurs and innovative businesses. Today, those principles guide our growth and define our approach to investment.
              </p>
              <div className="magazine-columns-v5">
                <div className="magazine-column-v5">
                  <h3 className="column-title-v5">Innovation Investment</h3>
                  <p className="column-text-v5">We believe in the power of breakthrough technologies to reshape industries and create unprecedented value.</p>
                </div>
                <div className="magazine-column-v5">
                  <h3 className="column-title-v5">Strategic Partnership</h3>
                  <p className="column-text-v5">Beyond capital, we provide strategic guidance, industry expertise, and network access to our portfolio companies.</p>
                </div>
              </div>
            </div>
            <div className="magazine-sidebar-v5">
              <div className="sidebar-item-v5">
                <h4 className="sidebar-title-v5">Our Values</h4>
                <ul className="sidebar-list-v5">
                  <li>Innovation First</li>
                  <li>Bold Thinking</li>
                  <li>Strategic Focus</li>
                  <li>Sustainable Growth</li>
                </ul>
              </div>
              <div className="sidebar-item-v5">
                <h4 className="sidebar-title-v5">Investment Areas</h4>
                <div className="sidebar-tags-v5">
                  <span className="tag-v5">Technology</span>
                  <span className="tag-v5">Biotech</span>
                  <span className="tag-v5">Cybersecurity</span>
                  <span className="tag-v5">Blockchain</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  // Version 6: Interactive Hover Design
  if (version === '6') {
    return (
      <section className="what-we-believe-v6">
        <div className="interactive-container-v6">
          <div className="interactive-header-v6">
            <h2 className="interactive-title-v6">What We Believe In</h2>
            <p className="interactive-subtitle-v6">Hover over each principle to explore our philosophy</p>
          </div>
          <div className="interactive-grid-v6">
            <div className="interactive-item-v6" data-bg="innovation">
              <div className="item-content-v6">
                <div className="item-icon-v6">🔬</div>
                <h3 className="item-title-v6">Innovation</h3>
                <p className="item-description-v6">Breakthrough technologies that transform industries and create new markets.</p>
              </div>
            </div>
            <div className="interactive-item-v6" data-bg="partnership">
              <div className="item-content-v6">
                <div className="item-icon-v6">🤝</div>
                <h3 className="item-title-v6">Partnership</h3>
                <p className="item-description-v6">Strategic alliances that accelerate growth and maximize potential.</p>
              </div>
            </div>
            <div className="interactive-item-v6" data-bg="excellence">
              <div className="item-content-v6">
                <div className="item-icon-v6">⚡</div>
                <h3 className="item-title-v6">Excellence</h3>
                <p className="item-description-v6">Uncompromising standards in everything we do, from investment to execution.</p>
              </div>
            </div>
            <div className="interactive-item-v6" data-bg="growth">
              <div className="item-content-v6">
                <div className="item-icon-v6">📈</div>
                <h3 className="item-title-v6">Growth</h3>
                <p className="item-description-v6">Sustainable expansion that creates lasting value for all stakeholders.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  // Default/Original version
  return (
    <section className="what-we-believe-section">
      <div className="what-we-believe-container">
        <div className="section-content">
          
          <div className="left-content">
            <div className="belief-image-container">
              <img 
                src="/images/museum.png" 
                alt="Historic Business Executive" 
                className="historical-image"
              />
              <div className="decorative-element">
                <div className="decorative-icon">●</div>
              </div>
              <div className="in-good-company">
                <h2 className="section-title">
                    Building the Future
                </h2>
                <p className="section-description">
                  We distinguish ourselves not only through excellence but by approaching challenges with a unique perspective. Our sustained success empowers us to deliver future-focused business and technology solutions.
                </p>
              </div>
            </div>
          </div>

          {/* Right Side - What We Believe In and Additional Sections */}
          <div className="right-content">
            <div className="believe-section">
              <h2 className="section-title">Our Philosophy</h2>
              <p className="section-description">
                Spanning six continents, our portfolio encompasses investments in software development, cybersecurity, blockchain and crypto, electronic intrusion detection, techucation, biotech & longevity, immigration services, corporate services, business advisory, and Emirati & contemporary art. We are committed to unlocking global opportunities.
              </p>
              <a href="#portfolio" className="section-link">
                OUR SERVICES →
              </a>
            </div>

            <div className="additional-sections">
              <div className="future-section">
                <div className="static-section-divider"></div>
                <h3 className="subsection-title">Technology & Innovation</h3>
                <p className="subsection-description">
                  From AI-powered cybersecurity and blockchain education to biotechnology investments, we drive innovation across industries while maintaining the highest standards of data protection and regulatory compliance.
                </p>
              </div>

              <div className="heritage-section">
                <div className="static-section-divider"></div>
                <h3 className="subsection-title">Heritage & Legacy</h3>
                <p className="subsection-description">
                  With a rich history dating back to 1994, Rayad Group has consistently championed innovation and excellence, leaving a lasting impact on the industries we serve.
                </p>
              </div>

            </div>
          </div>

        </div>
      </div>

      {/* Since 1882 Decorative Element */}
      <div className="since-element">
        <span className="since-text">SINCE</span>
        <span className="since-year">1994</span>
      </div>
    </section>
  );
};

export default WhatWeBelieve;